module.exports = __webpack_public_path__ + "static/media/avnt-feed-mockup.0b71ab99.png";